import React from 'react';
import { Fab, Tooltip, Zoom } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useLocation, useNavigate } from 'react-router-dom';

const HELPDESK_ROUTE = '/home/CRM-helpdesk';

/**
 * Floating Help Desk button shown on every authenticated CRM page.
 * Matches the CRM design system (primary blue #1570EF) and navigates
 * the user to the CRM Help Desk route on click.
 */
const HelpDeskFab = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show the button on the Help Desk page itself.
  if (location.pathname === HELPDESK_ROUTE) return null;

  // Lift the button above the mobile bottom navigation (~10% height bar).
  const isMobile = window.innerWidth <= 820;

  return (
    <Tooltip title="Help Desk" placement="left" TransitionComponent={Zoom} arrow>
      <Fab
        aria-label="Open Help Desk"
        onClick={() => navigate(HELPDESK_ROUTE)}
        sx={{
          position: 'fixed',
          right: { xs: 16, sm: 24 },
          bottom: isMobile ? 88 : 28,
          zIndex: 1300,
          width: 60,
          height: 60,
          backgroundColor: '#1570EF',
          color: '#FFFFFF',
          boxShadow: '0px 6px 16px rgba(21, 112, 239, 0.45)',
          '&:hover': {
            backgroundColor: '#0E5BC4',
          },
        }}
      >
        <SupportAgentIcon sx={{ fontSize: 30 }} />
      </Fab>
    </Tooltip>
  );
};

export default HelpDeskFab;
